<!-- 驳回弹窗 -->
<template>
    <el-dialog title="查看详情" :visible.sync="isShow" top="100px" width="30%" custom-class="custom-dialog-class"
        @close="closeRejectDialog">
        <div class="dialog-container">
            <el-form label-width="120px">
                <el-form-item label="驳回原因：" prop="reason" >
                    <el-input type="textarea" v-model="reason"  :rows="5"/>
                </el-form-item>
            </el-form>
        </div>
        <template #footer>
            <div style="text-align: center;">
                <el-button type="primary" @click="submitReject">驳 回</el-button>
                <el-button @click="closeRejectDialog(false)">取 消</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import { post } from '@/api/http';
export default {
    name: 'RejectDialog',
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        rowId: {
            type: String,
            default: ''
        },
        closeRejectDialog: {
            type: Function,
            default: () => { }
        },
        closeDialog: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            reason: '', // 驳回原因
        }
    },
    computed: {
        isShow: {
            get() {
                return this.isOpen;
            },
            set(val) {
                this.closeDialog(val);
            }
        }
    },
    methods: {
        // 提交错误原因 
        async submitReject() {
            try {
                const params = {
                    id: this.rowId,
                    rejectReason: this.reason
                }
                const result = await post("diet/audit/reject", params);
                const { code } = result;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.closeDialog(); // 关闭弹窗
                    this.closeRejectDialog(); // 关闭详情弹窗
                    this.$emit('fetchTableList');
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.itemContainer {
    display: flex;
    gap: 10px;

    .item {
        background-color: rgb(203, 226, 255);
        color: rgba(26, 124, 242);
        border-radius: 50px;
        padding: 0 8px;
        min-width: 60px;
        text-align: center;
    }
}
</style>